import {SUMMARY_PAYMENTS_STATUSES} from '@chekin/core';
import {PAYMENT_TITLE} from '@chekin/shared/home';
import {useSummary} from 'context/summary';

const SETTLED = [SUMMARY_PAYMENTS_STATUSES.complete, SUMMARY_PAYMENTS_STATUSES.inactive];

function usePendingPayments() {
  const {data: summary} = useSummary();

  return (Object.keys(PAYMENT_TITLE) as Array<keyof typeof PAYMENT_TITLE>)
    .filter(kind => {
      const payment = summary?.[kind];
      return (
        payment?.active && !SETTLED.includes(payment.status as SUMMARY_PAYMENTS_STATUSES)
      );
    })
    .map(kind => ({kind, titleKey: PAYMENT_TITLE[kind]}));
}

export {usePendingPayments};
